import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from "@angular/core";
import { animSlideFromTop } from "../../../animations/slide.animations";
import { VFlagToggleComponent } from "../v-flag-toggle/v-flag-toggle.component";
import './v-flag-toggle-list-item.component.scss';

@Component({
    selector: "v-flag-toggle-list-item",
    template: require("./v-flag-toggle-list-item.component.html"),
    animations: [animSlideFromTop]
})
export class VFlagToggleListItemComponent implements OnInit, OnChanges {
    @Input() description: string;
    @Input() tiny: boolean;
    @Input() title: string;
    @Input() disabled: boolean;

    @Input() flag: any;
    @Input() currentFlags: any;
    @Output() currentFlagsChange = new EventEmitter<any>();
    @Output() onChanged = new EventEmitter<boolean>();

    @ViewChild(VFlagToggleComponent) toggleFlagComponent: VFlagToggleComponent;

    // state
    hasFlag: boolean;

    ngOnInit(): void {
        this.updateHasFlag();
    }

    ngOnChanges(): void {
        this.updateHasFlag();
    }

    toggle(): void {
        this.toggleFlagComponent?.toggle();
    }

    onToggled(): void {
        this.updateHasFlag();

        this.currentFlagsChange.emit(this.currentFlags);
        this.onChanged.emit(this.hasFlag);
    }

    // ---

    private updateHasFlag(): void {
        this.hasFlag = (this.currentFlags & this.flag) === this.flag;
    }
}
